function Live() {
  return <h2>Live Page</h2>;
}

export default Live;
